<template>
  <div
    class="container"
    :class="{
      success: success,
      warning: warning,
      error: error,
    }"
  >
    {{ message }}
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CalloutBox",
  props: {
    message: String,
    error: Boolean,
    warning: Boolean,
    success: Boolean,
  },
};
</script>

<style scoped>
.container {
  padding: 16px 20px;
  color: white;
  font-weight: 500;
  border-radius: 12px;
  margin: 12px 0;
  line-height: 1.5;
  border-left: 4px solid transparent;
}
.success {
  background-color: #4e9a52;
  border-left-color: #3a7d3e;
}
.warning {
  background-color: #8a7e72;
  border-left-color: #6b6058;
}
.error {
  background-color: #c83d4a;
  border-left-color: #a02e38;
}
</style>

